import useHeaderManagement from "./header-management-history.hooks";
import {t} from "i18next";
import React from "react";
import convertTimestamp from "./header-management-history.hooks";

const HeaderManagementHistory = ({data, setUserManagementOpen}) => {
    return (
        <>
            <div className='bg-[#EEEEEE] rounded-[6px] px-[12px] py-[7px] cursor-pointer'
                 onClick={() => setUserManagementOpen(true)}>
                <p className='text-[#666666]'>{t("USER_DETAIL:CREATED_BY")} {" "}
                    <strong>{data?.created_by}</strong> {t("USER_DETAIL:ON")} {" "}
                    <strong>{convertTimestamp(data?.created_at, true)}</strong> | {t("USER_DETAIL:LAST_MODIFIED_BY")} {" "}
                    <strong>{data?.updated_by}</strong> {t("USER_DETAIL:ON")} {" "}
                    <strong>{convertTimestamp(data?.updated_at, true)}</strong></p>
            </div>
        </>
    )
}

export default HeaderManagementHistory;